import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 18 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M3.75 4.875C4.16421 4.875 4.5 5.21079 4.5 5.625V8.625H9V5.625C9 5.21079 9.33579 4.875 9.75 4.875C10.1642 4.875 10.5 5.21079 10.5 5.625V13.125C10.5 13.5392 10.1642 13.875 9.75 13.875C9.33579 13.875 9 13.5392 9 13.125V10.125H4.5V13.125C4.5 13.5392 4.16421 13.875 3.75 13.875C3.33579 13.875 3 13.5392 3 13.125V5.625C3 5.21079 3.33579 4.875 3.75 4.875Z",
      fill: "#3F3F46"
    }, null, -1),
    _createElementVNode("path", {
      d: "M12.75 9.40258V7.875H15.5625V13.875H13.8619V9.40258H12.75Z",
      fill: "#3F3F46"
    }, null, -1)
  ])))
}
export default { render: render }